# 2022 SEEK API migration

The SEEK API replaces a number of legacy SEEK integrations, including the [Job Posting API] and [SEEK Application Export].

Migrating to the SEEK API provides a number of benefits to SEEK and its partners:

- The SEEK API is a single point of access to SEEK’s hirer marketplace.
  For example, the same [representation of a position] is used for [Job Posting], [Optimised Apply] and Talent Search Connect.

- Using GraphQL makes it easier for SEEK to introduce new features without disrupting existing integrations.
  You have the choice of when to broaden your software to take advantage of new SEEK API features.

- A single set of OAuth2 credentials are used to [authenticate your software to the SEEK API](/auth).
  This replaces multiple custom authentication mechanisms that have fallen behind industry best practices.

[Job Posting API]: /migration-guides/job-posting-api
[Job Posting]: /use-cases/job-posting
[Optimised Apply]: /use-cases/application-export
[representation of a position]: /schema/named-type/PositionProfile
[SEEK Application Export]: /migration-guides/sae
